import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Chatbot from "../Components/Chatbot.tsx"; 

interface MainProps {
    onSignOutSuccess: () => void;
}

const Main: React.FC<MainProps> = ({ onSignOutSuccess }) => {
    const navigate = useNavigate();

    useEffect(() => {
        const authToken = localStorage.getItem('authToken');
        if (!authToken) {
            navigate('/Authpage');
        }
    }, [navigate]);

    return (
        <div>
            <Chatbot onSignOutSuccess={onSignOutSuccess} />
        </div>
    );
};

export default Main;